import * as React from "react";
import { connect } from "react-redux";
import { State } from "../../../state";
import { getUnmappedAccounts } from "../../model/spread/selector";
import "./UnmappedAccountsIndicator.scss";

interface UnmappedAccountsIndicatorProps {
  unmappedAccountsCount: number | undefined;
  openPanel: () => void;
}

export class UnmappedAccountsIndicator extends React.Component<
  UnmappedAccountsIndicatorProps
> {
  public render() {
    const { unmappedAccountsCount } = this.props;

    if (!unmappedAccountsCount) {
      return null;
    }

    return (
      <div className="UnmappedAccountsIndicator">
        <div className="UnmappedAccountsIndicator__text">unmapped accounts</div>
        <div
          className="UnmappedAccountsIndicator__count"
          onClick={this.props.openPanel}
        >
          {this.props.unmappedAccountsCount}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State) => ({
  unmappedAccountsCount: getUnmappedAccounts(state).length
});

export default connect(mapStateToProps)(UnmappedAccountsIndicator);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/unmappedAccounts/UnmappedAccountsIndicator.tsx